export const RECEIVE_MENU_LIST = 'RECEIVE_MENU_LIST'

export const FETCH_MENU_LIST = 'FETCH_MENU_LIST'
